import http from '../utils/http';
import { interpolate, unParseQuery } from 'utils/string';
import { SKILL_URL, SKILL_ABSOLUTE_URL, USER_SKILLSV2_URL, SKILL_URL_V1 } from '../constants/endpoints';
import type { AddSkill } from 'interface/skill';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchAll(_params: ServiceParams = {}) {
  const data = await http.get(SKILL_URL);

  return data;
}

export async function fetchAllV1(params: ServiceParams = {}) {
  const data = await http.get(SKILL_URL_V1 + unParseQuery(params || { size: 1000 }));

  return data;
}

export async function fetchByUserId(userId: ServiceId) {
  const data = await http.get(interpolate(USER_SKILLSV2_URL, { userId }));

  return data;
}

export async function fetchById(id: ServiceId) {
  const { data } = await http.get(interpolate(SKILL_ABSOLUTE_URL, { id }));

  return data;
}

export async function create(skill: AddSkill) {
  return await http.post(SKILL_URL_V1, {
    body: skill,
  });
}

export async function update(skill: AddSkill, id: ServiceId) {
  return await http.put(interpolate(SKILL_ABSOLUTE_URL, { id }), {
    body: skill,
  });
}

export async function remove(id: ServiceId) {
  return await http.delete(interpolate(SKILL_ABSOLUTE_URL, { id }));
}
